<template>
  <div id="personal">
    <myhead title="私人订制"></myhead>
    <!-- <div class="content">
      若您想要独一无二的伪装APP
      <br />我们还提供私人定制服务
    </div>
    <div class="content-desc">
      <br />因为独一无二·所以最安全
    </div>
    <personalBotton></personalBotton> -->
    <div class="cont"></div>
  </div>
</template>
<script>
import myhead from "../common/head";
import personalBotton from "../common/personalBotton";

import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
   metaInfo: {
    title:"私人订制",
  },
  name: "personal",
  data() {
    return {
      msg: "私人订制"
    };
  },
  mounted: function() {
    
    this.$point.init(new Date());
    store.dispatch('hideLoading');
    
    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  },
  components: {
    myhead,
    personalBotton
  }
};
</script>
<style  scoped>
#personal {
  width: 750px;
  height: auto;
  background-size: cover;
  white-space: nowrap;
  overflow: hidden;
}
.cont{
   width: 750px;
  height: 1930px;
  background-image: url("../../assets/img/person-back@2x.png");
  background-size: cover;
  white-space: nowrap;
  overflow: hidden;
}

.content {
  height: 132px;
  font-size: 46px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 66px;
  background: linear-gradient(
    148deg,
    rgba(233, 205, 181, 1) 0%,
    rgba(214, 170, 150, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 44px auto 0px;
}
.content-desc {
  height: 118px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/personal.vue